import { useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/api/client'
import { 
  tenantGetMoMessages, 
  tenantGetMoMessage, 
  tenantGetMoMessageStats,
  type TenantGetMoMessagesData,
  type TenantGetMoMessageData
} from '@/lib/api/generated/sdk.gen'

// 上行消息数据接口
export interface MoMessage {
  id: number
  messageId: string
  mobile: string
  content: string
  operator: string
  province: string
  city: string
  channelId: number
  channelMessageId: string
  status: string
  errorCode?: string
  errorMessage?: string
  processedAt?: string
  webhookSent: boolean
  webhookSentAt?: string
  operatorSentAt?: string
  pushStatus: string
  pushRetryCount?: number
  pushMaxRetryCount?: number
  pushResponse?: string
  createdAt: string
  updatedAt: string
}

// 上行消息统计接口
export interface MoMessageStats {
  totalCount: number
  receivedCount: number
  processedCount: number
  failedCount: number
  updatedAt: string
}

// 查询上行消息列表
export const useMoMessages = (params?: {
  page?: number
  size?: number
  mobile?: string
  status?: string
  operator?: string
  pushStatus?: string
  startDate?: string
  endDate?: string
  content?: string
}) => {
  return useQuery({
    queryKey: ['mo-messages', params],
    queryFn: async () => {
      const queryParams: TenantGetMoMessagesData['query'] = {
        page: params?.page || 1,
        size: params?.size || 10,
      }
      
      if (params?.mobile) {
        queryParams.mobile = params.mobile
      }
      
      if (params?.status && params.status !== 'ALL') {
        queryParams.status = params.status
      }
      
      if (params?.operator && params.operator !== 'ALL') {
        queryParams.operator = params.operator
      }
      
      if (params?.pushStatus && params.pushStatus !== 'ALL') {
        queryParams.pushStatus = params.pushStatus
      }
      
      if (params?.content) {
        queryParams.content = params.content
      }
      
      if (params?.startDate) {
        queryParams.startDate = params.startDate
      }
      
      if (params?.endDate) {
        queryParams.endDate = params.endDate
      }
      
      const response = await tenantGetMoMessages({
        client: apiClient,
        query: queryParams
      })
      
      return response.data
    },
    enabled: true,
  })
}

// 查询上行消息详情
export const useMoMessage = (id: number) => {
  return useQuery({
    queryKey: ['mo-message', id],
    queryFn: async () => {
      const response = await tenantGetMoMessage({
        client: apiClient,
        path: { id }
      })
      
      return response.data
    },
    enabled: !!id,
  })
}

// 查询上行消息统计
export const useMoMessageStats = () => {
  return useQuery({
    queryKey: ['mo-message-stats'],
    queryFn: async () => {
      const response = await tenantGetMoMessageStats({
        client: apiClient
      })
      
      return response.data as MoMessageStats
    },
    enabled: true,
  })
}
